"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeAuth = exports.Auth = void 0;
const ObservableEntity_1 = require("./ObservableEntity");
class Auth extends ObservableEntity_1.ObservableEntity {
}
exports.Auth = Auth;
function makeAuth() {
    return new AuthImp();
}
exports.makeAuth = makeAuth;
class AuthImp extends Auth {
    login(username, password) {
        return Promise.reject(this.functionNotInjectedError("login"));
    }
    logout() {
        return Promise.reject(this.functionNotInjectedError("logout"));
    }
    refreshAuthenticatedUser() {
        return Promise.reject(this.functionNotInjectedError("getCurrentAuthenticatedUser"));
    }
    functionNotInjectedError(functionName) {
        return new Error(`Auth function ${functionName} has not been injected`);
    }
}
